import React, { forwardRef } from 'react'

interface InputProps {
    type?: 'text' | 'number' | 'email' | 'password' | 'date' | 'time' | string
    id?: string
    name?: string
    placeholder?: string
    value?: string | number
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    autoFocus?: boolean
    className?: string
    min?: string | number
    max?: string | number
    step?: number
    disabled?: boolean
    success?: boolean
    error?: boolean
    hint?: string
    size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
    sm: 'h-10 text-xs px-3 py-2',
    md: 'h-11 text-sm px-4 py-2.5',
    lg: 'h-13 text-base px-5 py-3'
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    (
        {
            type = 'text',
            id,
            name,
            placeholder,
            value,
            onChange,
            onFocus,
            onBlur,
            onKeyDown,
            autoFocus = false,
            className = '',
            min,
            max,
            step,
            disabled = false,
            success = false,
            error = false,
            hint,
            size = 'md'
        },
        ref
    ) => {
        let inputClasses = `w-full rounded-lg border appearance-none shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 ${sizeClasses[size]} ${className}`

        if (disabled) {
            inputClasses += ` text-gray-500 border-gray-300 cursor-not-allowed dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700`
        } else if (success) {
            inputClasses += ` text-success-500 border-success-400 focus:outline-none focus:ring-2 focus:ring-brand-500 dark:text-success-400 dark:border-success-500`
        } else {
            inputClasses += ` bg-transparent text-gray-800 border-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-500 dark:border-gray-700 dark:text-white/90 dark:focus:border-brand-800`
        }

        return (
            <div className='relative'>
                <input
                    ref={ref}
                    type={type}
                    id={id}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    autoFocus={autoFocus}
                    min={min}
                    max={max}
                    step={step}
                    disabled={disabled}
                    className={inputClasses}
                />

                {error && <p className='text-error-500 text-xs mt-1'>Este campo é obrigatório</p>}

                {hint && (
                    <p
                        className={`mt-1.5 text-xs ${
                            error ? 'text-error-500' : success ? 'text-success-500' : 'text-gray-500'
                        }`}
                    >
                        {hint}
                    </p>
                )}
            </div>
        )
    }
)

export default Input
